import Spritesheet from "./Spritesheet";
import { Settings } from "../../Settings";
import CharacterSpritesheet from "./CharacterSpritesheet";
import TileSpritesheet from "./TileSpritesheet";
import TileTypeBackgroundSpritesheet from "./TileTypeBackgroundSpritesheet";
import ItemOverlaySpritesheet from "./ItemOverlaySpritesheet";
import StaticFixtureSpritesheet from "./StaticFixtureSpritesheet";
import MonsterSpritesheet from "./MonsterSpritesheet";
import TileOverlaySpritesheet from "./TileOverlaySpritesheet";
import SpriteAnimationManager from "./SpriteAnimationManager";
import GervaisAnimatedSpritesheet from "./GervaisAnimatedSpritesheet";
import { SpellFXMetadata } from "./SpellFXMetadata";
import TileDamageSpriteOverlay from "./TileDamageSpriteOverlay";
import OreSpriteOverlay from "./OreSpriteOverlay";

export default class Sprites {
    /**
     */
    constructor() {

        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = new SpriteAnimationManager();
        /**
         * @constant
         * @type {TileDamageSpriteOverlay}
         */
        this.tileDamageSpriteOverlay = new TileDamageSpriteOverlay();
        /**
         * @constant
         * @type {OreSpriteOverlay}
         */
        this.oreSpriteOverlay = new OreSpriteOverlay();

        /**
         * @type {boolean}
         */
        this.loaded = false;

        /**
         * @type {Spritesheet}
         */
        this.tileSpritesheet = new TileSpritesheet('spritesheet/tile_spritesheet.png', Settings.tile.size);
        /**
         * @type {TileTypeBackgroundSpritesheet}
         */
        this.tileTypeBackgroundSpritesheet = new TileTypeBackgroundSpritesheet('spritesheet/tile_type_background.png', Settings.tile.size);
        /**
         * @type {CharacterSpritesheet}
         */
        this.characterSpritesheet = new CharacterSpritesheet('spritesheet/character_spritesheet.png', Settings.tile.size, this.spriteAnimationManager);
        /**
         * @type {ItemOverlaySpritesheet}
         */
        this.itemOverlaySpritesheet = new ItemOverlaySpritesheet('spritesheet/item_overlay_spritesheet.png', Settings.tile.size * 3, this.spriteAnimationManager);

        /**
         * @type {StaticFixtureSpritesheet}
         */
        this.staticFixtureSpritesheet = new StaticFixtureSpritesheet('spritesheet/static_fixture_spritesheet.png', Settings.tile.size);

        /**
         * @type {MonsterSpritesheet}
         */
        this.monsterSpritesheet = new MonsterSpritesheet('spritesheet/monsters0.png', 'spritesheet/monsters1.png', Settings.tile.size, this.spriteAnimationManager);

        /**
         * @type {TileOverlaySpritesheet}
         */
        this.tileSpriteOverlaySpritesheet = new TileOverlaySpritesheet('spritesheet/tile_overlay.png', Settings.tile.size, 
            this.spriteAnimationManager, this.tileDamageSpriteOverlay, this.oreSpriteOverlay);

        /**
         * @type {GervaisAnimatedSpritesheet}
         */
        this.spellFxSpritesheet = new GervaisAnimatedSpritesheet('spritesheet/SpellFX.png', 31, SpellFXMetadata, 7, this.spriteAnimationManager);

    }

    /**
     * @returns {boolean}
     */
    isInitialized() {
        if (!this.loaded) {
            this.loaded = this.tileSpritesheet.loaded
                && this.tileTypeBackgroundSpritesheet.loaded
                && this.characterSpritesheet.loaded
                && this.itemOverlaySpritesheet.loaded
                && this.staticFixtureSpritesheet.loaded
                && this.monsterSpritesheet.isLoaded() // <-- this one is a delegate class.
                && this.tileSpriteOverlaySpritesheet.loaded
                && this.spellFxSpritesheet.loaded;
        }

        return this.loaded;
    }
}
